/** True when the claim/session config says this single-use link is already paid. */
export function isLinkUsageConsumed(config?: {
  usage?: { state?: string };
} | null): boolean {
  return config?.usage?.state === "consumed";
}
